import type { ReactNode } from 'react'

import type { LANG, SORT_BY, WithLoadingState } from '@eshop/type'

import css from './index.module.css'

import { Pagination } from '#/global/component/Pagination/Pagination'
import { ProductSortBy } from '#/global/component/Product/ProductSortBy'

interface Props {
    children: ReactNode
    lang: LANG
    page: number
    productsCount: number
    setPage: (page: number) => void
    setSortBy: (sortBy: SORT_BY) => void
    sortBy: SORT_BY
}

export const LayoutGrid = ({
    children,
    lang,
    loadingState,
    page,
    productsCount,
    setPage,
    setSortBy,
    sortBy,
}: WithLoadingState<Props>) => {
    return (
        <div className="r-product-layout-grid">
            <div className={css.row}>
                {loadingState
                    ? <div className="pagination loading" />
                    : (
                            <>
                                <ProductSortBy lang={lang} setSortBy={setSortBy} sortBy={sortBy} />
                                <Pagination itemsCount={productsCount} itemsPerPage={24} page={page} position="top" setPage={setPage} />
                            </>
                        )}
            </div>
            <div className={css.grid}>{children}</div>
            <div className={`${css.row} ${css.bottom}`}>
                {loadingState
                    ? <div className="pagination loading" />
                    : (
                            <Pagination
                                itemsCount={productsCount}
                                itemsPerPage={24}
                                page={page}
                                position="bottom"
                                setPage={setPage}
                            />
                        )}
            </div>
        </div>
    )
}
